import { get } from "../../service/api";

const GetSbIncome = async (payload) => {
  try {
    const response = await get(`/admin/sbIncome`);
    return response;
  } catch (error) {
    console.error("Error admin sbIncome:", error);
    throw error;
  }
};

export default GetSbIncome;
